// src/utils/tutorReviewHelpers.js
//
// Slice 1b: the Model-A bundle/quota/eligibility helpers are removed (dead since the
// Model-B Tutor Review rewrite + BundlePackBadge removal). Only the still-live reference-
// code formatter remains -- used by the manual-payment PayMe page + Account.
//
// Migrated verbatim from prototype/between-the-lines-v2.html lines 7999-8004.
export const getReferenceCode = (id) => {
    if (!id) return '';
    const clean = String(id).toUpperCase().replace(/[^A-Z0-9]/g, '');
    const last8 = clean.slice(-8);
    return last8.match(/.{1,4}/g)?.join('-') || last8;
};
